var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["boss-table-2-layout", { "boss-table-2-layout-half": _vm.half }],
      attrs: { "data-test": "layout" },
    },
    [
      _c(
        "div",
        {
          staticClass: "boss-table-2-item boss-table-2-item-head",
          attrs: { "data-test": "label" },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
          _c("div", { staticClass: "boss-color-red" }, [
            _vm._v(
              "\n      ※スカウト件数調査ではこの検索条件は無効になります。\n    "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "boss-table-2-item",
            "boss-table-2-item-body",
            { "boss-table-2-item-body-has-child": _vm.hasChild },
            { "is-modified": _vm.isModified },
          ],
          attrs: { "data-test": "body" },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }